import React, { useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Settings() {
  const { user, setUser, refreshUser } = useAuth();
  const [form, setForm] = useState({
    name: user?.name || "",
    business_name: user?.business_name || "",
    business_address: user?.business_address || "",
  });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await api.put("/auth/profile", form);
      setUser(res.data);
      await refreshUser();
      toast.success("Profile saved. This appears on your invoices & agreements.");
    } catch { toast.error("Could not save"); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <PageHeader title="Settings" subtitle="Your business details appear on generated invoices and agreements." />
      <Card className="p-6 max-w-2xl">
        <form onSubmit={save} className="space-y-4">
          <div className="space-y-1.5"><Label>Your name</Label><Input value={form.name} onChange={set("name")} data-testid="settings-name-input" /></div>
          <div className="space-y-1.5"><Label>Business name</Label><Input value={form.business_name} onChange={set("business_name")} data-testid="settings-business-name-input" placeholder="Shown as the sender on invoices" /></div>
          <div className="space-y-1.5"><Label>Business address</Label><Textarea value={form.business_address} onChange={set("business_address")} data-testid="settings-business-address-input" placeholder="12 Market St, Lagos" /></div>
          <div className="space-y-1.5"><Label>Email</Label><Input value={user?.email || ""} disabled /></div>
          <Button type="submit" disabled={saving} data-testid="settings-save-button">{saving ? "Saving..." : "Save changes"}</Button>
        </form>
      </Card>
    </div>
  );
}
